<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :model="DutySituationForm">
        <FormItem label="时间">
          <DatePicker type="daterange" v-model="DutySituationForm.signTime" placeholder="选择日期"
                      @on-change="getDutySituationData" clearable @on-clear="clearData"></DatePicker>
        </FormItem>
      </Form>
      <Table ref="DutySituationRefs" :data="DutySituationData" border :columns="DutySituationColumns"
             :loading="DutySituationLoading"></Table>
      <Button type="primary" style="float: left;margin-top: 10px" @click="exportDutySituation">导出附件
      </Button>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'DutySituation',
  data() {
    return {
      DutySituationData: [],
      DutySituationColumns: [
        {title: '单位', key: 'dept', align: 'center'},
        {
          title: '带班领导',
          key: 'dept',
          align: 'center',
          children: [
            {title: '签到', key: 'leaderSignNumber', align: 'center'},
            {title: '签退', key: 'leaderSignOutNumber', align: 'center'},
            {title: '签到/签退率', key: 'leaderSignRate', align: 'center'}
          ]
        },
        {
          title: '值班人员',
          key: 'dept',
          align: 'center',
          children: [
            {title: '签到', key: 'userSignNumber', align: 'center'},
            {title: '签退', key: 'userSignOutNumber', align: 'center'},
            {title: '签到/签退率', key: 'userSignRate', align: 'center'}
          ]
        },
        {title: '总签到率', key: 'allSignRate', align: 'center'}
      ],
      DutySituationLoading: false,
      DutySituationForm: {
        signTime: []
      }
    }
  },
  mounted() {
    this.DutySituationForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
    this.getDutySituationData()
  },
  methods: {
    exportDutySituation() {
      this.$refs.DutySituationRefs.exportCsv({
        filename: this.$moment(new Date()).format('yyyy-MM-DD') + '应急值班工作情况',
      })
    },
    clearData() {
      this.DutySituationForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      this.getUsageSituationData()
    },
    getDutySituationData() {
      this.DutySituationLoading = true
      let request = {
        beginDate: new Date(this.DutySituationForm.signTime[0]),
        endDate: new Date(this.DutySituationForm.signTime[1]),
      }
      this.$http.post('/api/getEmergencyDutySituation', request).then(res => {
        if (res.status === 200) {
          this.DutySituationData = res.data
          this.DutySituationLoading = false
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

</style>
